import DataTable from 'react-data-table-component';
import { translate } from 'react-switch-lang';

const TpeColumns = (props) => {
  const tpeColumns: any = [
    {
      name: props.t('tpe.name'),
      selector: (row) => row.name,
      sortable: true,
      center: true,
    },
    {
      name: props.t('tpe.type'),
      selector: (row) => row.type,
      sortable: true,
      center: true,
    },
    {
      name: props.t('tpe.creation_year'),
      selector: (row) => row.anneeCreation,
      sortable: true,
      center: true,
    },
    {
      id: 'Action',
      name: props.t('actions'),
      selector: (row) => row.action,
      sortable: false,
      center: true,
    },
  ];
  return <DataTable columns={tpeColumns} data={props.data} />;
};

export default translate(TpeColumns);